import { render, staticRenderFns } from "./DialogProgress.vue?vue&type=template&id=56dadecc"
import script from "./DialogProgress.vue?vue&type=script&lang=js"
export * from "./DialogProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports